import { z } from 'zod';
import type { ContractError } from './errors';
import { toContractError } from './errors';
import type { Result } from './result';

const AdminAccessSchema = z.object({
  is_admin: z.boolean(),
});

export type AdminAccess = z.infer<typeof AdminAccessSchema>;

export const parseAdminAccess = (
  raw: unknown,
): Result<AdminAccess, ContractError> => {
  const parsed = AdminAccessSchema.safeParse(raw);
  if (!parsed.success) {
    return {
      ok: false,
      err: toContractError(parsed.error, { source: 'http' }),
    };
  }
  return {
    ok: true,
    value: parsed.data,
  };
};
